import { ProductTransactionStatus } from '@gooduncles/gu-app-schema';
import { Col, Row, Skeleton, Tag } from 'antd';
import { FC } from 'react';
import { formatNumber } from 'src/utils/common';

import useSWRProductInboundTransaction from 'src/hooks/swr/useSWRProductInboundTransaction';

import InventoryName from 'src/atomic-components/molecules/Inventory/InventoryName';

interface InboundTransactionRowProps {
  transactionId: string;
}

const InboundTransactionRow: FC<InboundTransactionRowProps> = ({ transactionId }) => {
  const { productInboundTransaction, isLoading, error } = useSWRProductInboundTransaction(transactionId);

  if (isLoading) {
    return <Skeleton active paragraph={{ rows: 1 }} />;
  }

  if (error || !productInboundTransaction) {
    return <Row>데이터를 불러오는 중 오류가 발생했습니다.</Row>;
  }

  const changeAmount = productInboundTransaction.requestValue * productInboundTransaction.inventoryUnitRatio;

  const getStatusColor = (status: ProductTransactionStatus) => {
    switch (status) {
      case ProductTransactionStatus.COMPLETED:
        return 'success';
      case ProductTransactionStatus.PENDING:
        return 'warning';
      case ProductTransactionStatus.REJECTED:
      case ProductTransactionStatus.FAILED:
        return 'error';
      case ProductTransactionStatus.CANCELED:
        return 'default';
      default:
        return 'default';
    }
  };

  const getStatusText = (status: ProductTransactionStatus) => {
    switch (status) {
      case ProductTransactionStatus.PENDING:
        return '대기 중';
      case ProductTransactionStatus.COMPLETED:
        return '완료';
      case ProductTransactionStatus.REJECTED:
        return '거절됨';
      case ProductTransactionStatus.FAILED:
        return '실패';
      case ProductTransactionStatus.CANCELED:
        return '취소됨';
      default:
        return '';
    }
  };

  return (
    <Row gutter={[16, 8]} style={{ marginBottom: 8, alignItems: 'center' }}>
      <Col span={12}>
        {productInboundTransaction.inventoryId ? (
          <InventoryName inventoryId={productInboundTransaction.inventoryId} className='font12' />
        ) : (
          ''
        )}
      </Col>
      <Col span={3}>
        <span className={`stock-cell inbound ${productInboundTransaction.status}`}>{formatNumber(changeAmount)}</span>
      </Col>
      <Col span={3}>
        <span className='font12'>{productInboundTransaction.inventoryUnit}</span>
      </Col>
      <Col span={3}>{formatNumber(productInboundTransaction.requestValue)}</Col>
      <Col span={3}>
        <Tag color={getStatusColor(productInboundTransaction.status)}>
          {getStatusText(productInboundTransaction.status)}
        </Tag>
      </Col>
    </Row>
  );
};

export default InboundTransactionRow;
